<template>
  <span>
    <v-card max-width="420" class="d-inline-block">
      <v-img :src="src" class="white--text align-top">
        <v-card-title v-html="name"></v-card-title>
      </v-img>
      <v-card-actions>
        <v-btn :href="src" block>Get</v-btn>
      </v-card-actions>
    </v-card>
  </span>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import type { PropType } from 'vue'
import SWUpdate from "./components/general/SWUpdate.vue";

interface Item {
  name: string
}

export default defineComponent({
  name: "LogoComponent",
  components: {
    //
  },
  props: {
    name: {
      type: String,
      required: false,
      default: undefined,
    },
    src: {
      type: String,
      required: false,
      default: undefined,
    },
  },
});
</script>
